<template>
	<div>
		<div id="invoice" class="animated fadeIn">
			<div id="invoice-content" class="invoice overflow-auto">
				<div style="width: 100% !important;">
					<header class="container-fluid">
						<div class="row">
							<div class="col-8">
								<div>
									<h1>TELERADIO</h1>
									<div>GST : 19AAXFT5495P1ZN</div>
								</div>
								<div>Operative Office: 83/1 Bidhan Sarani, Shyambazar, Kolkata, WB</div>
								<div>Pin code: 700 004, Email: teleradiohub@gmail.com, M: 8100 550 440</div>
							</div>
							<div class="col-4 company-details" style="font-size: 18px;">
								<div class="address"> Voucher No: {{ data.id }} </div>
								<div class="email">Date: {{ format(data.created_at, 'DD/MM/YY hh:mm a') }}</div>
							</div>
							<div class="col-sm-12 text-center"><b style="font-size: 20px;">Postpaid Receipt Voucher</b></div>
						</div>
					</header>
					<main style="padding: 25px; font-size: 18px; margin-top: 10px; border: 1px solid #3989c6; border-radius: 5px;">
						<div class="container-fluid no-gutters">
							<div class="row">
								<div class="col-9 titles">
									<div>
										<span class="title-width"> Received With Thanks From</span>
										: &nbsp; <span style="text-transform: capitalize;">{{ data.entity_name }}</span>
									</div>
									<div>
										<span class="title-width">Type</span>
										: &nbsp; {{ data.entity_type == 'super_center' ? 'Super Center' : 'Center' }}
									</div>
									<div><span class="title-width">Basic Amount</span> : &nbsp; <i class="fa fa-inr"></i> {{ data.basic_amount }}</div>
									<div><span class="title-width">TDS Amount</span> : &nbsp; <i class="fa fa-inr"></i> {{ data.tds_amount }}</div>
									<div><span class="title-width">Total Amount</span> : &nbsp; <i class="fa fa-inr"></i> {{ data.total_amount }}</div>
									<div><span class="title-width">Mode Of Received</span> : &nbsp; {{ data.mode }}</div>
									<div v-if="data.transaction_id"><span class="title-width">Transaction ID</span> : &nbsp; {{ data.transaction_id }}</div>
									<div><span class="title-width">Payment Date</span> : &nbsp; {{ format(data.payment_date, 'DD/MM/YYYY') }}</div>
									<div><span class="title-width">Purpose</span> : &nbsp; Previous due settlement</div>
								</div>
							</div>
						</div>
					</main>
					<div style="text-align: right; font-size: 14px; color: #aaa; padding-top: 5px;">It is computer generated receipt, doesn't require any signature.</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			data: {},
		}
	},
	async mounted() {
		let id = this.$route.params.id;
		let res = await this.post('fetch-postpaid-payment-voucher-data', { id });
		if (res.success) this.data = res.data;

		window['pageStyle'].innerHTML = `@page {
			margin: 15px;
		}`;

		window.addEventListener('afterprint', this.afterPrint)
		setTimeout(() => {
			window.print();
		}, 10)
	},
	methods: {
		afterPrint() {
			window.removeEventListener('afterprint', this.afterPrint);
			this.$router.back();
		}
	}
}
</script>

<style scoped>
#invoice {
	padding: 15px;
}

.titles > div {
	margin-bottom: 20px;
}

@media print {
	#invoice {
		zoom: 80%;
	}
}
</style>
